<template>
  <v-app app>
    <HeadView :loading="loading"></HeadView>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Swal from 'sweetalert2';
import API from '../api';
import HeadView from './HeadView.vue';

export default {
  components: {
    HeadView
  },  
  data(){
    return { 
      token_street_shopping: null,
      loading: false,
    }
  },
  mounted() {
    this.token_street_shopping = localStorage.getItem('token_street_shopping');
    this.getAccessToPage();
  },
  methods: {
    getAccessToPage() {
      this.loading = true;
      if (this.token_street_shopping != null) {
        let formdata = new FormData();
        API.post('api.php', formdata, { headers: {
          'Authorization': this.token_street_shopping,
          'Route': 'validate_token_office'
        }}).then(response => {
          if (response.data.transaction_status && response.data.transaction_status.code == 200) {
            this.loading = false
          } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
            localStorage.removeItem('token_street_shopping');
            this.$router.push("/login");
          } else {
            Swal.fire({
              title: 'Error',
              html: 'Fallas en el servidor, intenta nuevamente',
              icon: 'error',
              confirmButtonText: 'Aceptar',
            });
          }
        }).catch(error => {
          Swal.fire({
            title: 'Error',
            html: 'Se ha presentado un error, intenta nuevamente',
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
          console.log('error front ' + error)
        }).finally(() => this.loading = false)
      } else {
        this.$router.push('/login');
      }
    },

    goView(path_route) {
      this.$router.push(path_route);
    },   
        
  }

}
</script>